module.exports = __webpack_public_path__ + "img/tab5.0a10d9de.png";